// src/pages/Futures/FuturesTradeTabs.js
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Box, Tabs, Tab, Snackbar, Alert
} from '@mui/material';
import FuturesOpenOrders from './FuturesOpenOrders';
import FuturesTradeHistory from './FuturesTradeHistory';
import { fetchOpenFutureTrades, fetchFutureTradeHistory } from '../../store/Slices/FuturesTradingSlice';
import { initializeSocket, disconnectSocket } from '../../services/futuresSocket';

const FuturesTradeTabs = () => {
  const dispatch = useDispatch();
  const { data: user, loading: userLoading } = useSelector((state) => state.user);
  const futuresState = useSelector((state) => state.futures || {});
  const { error, successMessage } = futuresState;

  const [value, setValue] = useState(0);
  const [socketError, setSocketError] = useState(null);

  useEffect(() => {
    if (!user?._id || userLoading) return;
    const sock = initializeSocket({ dispatch, userId: user._id });
    sock.on('connect_error', (err) => {
      setSocketError('Failed to connect to WebSocket');
      console.error('WebSocket connection error:', err);
    });
    return () => disconnectSocket();
  }, [dispatch, user?._id, userLoading]);

  useEffect(() => {
    if (user?._id && !userLoading) {
      dispatch(fetchOpenFutureTrades());
      dispatch(fetchFutureTradeHistory());
    }
  }, [dispatch, user?._id, userLoading]);

  const handleChange = (_e, newValue) => setValue(newValue);
  const handleSnackbarClose = () => {
    setSocketError(null);
    dispatch({ type: 'futures/clearMessages' });
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Snackbar
        open={!!error || !!socketError || !!successMessage}
        autoHideDuration={5000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={handleSnackbarClose} severity={error || socketError ? 'error' : 'success'} sx={{ width: '100%' }}>
          {error || socketError || successMessage}
        </Alert>
      </Snackbar>

      <Box sx={{
        borderBottom: 1, borderColor: 'divider',
        '& .MuiTabs-indicator': { bgcolor: '#F0B90B' }
      }}>
        <Tabs value={value} onChange={handleChange} aria-label="futures trade tabs" variant="fullWidth">
          <Tab label="Open Orders" />
          <Tab label="Trade History" />
        </Tabs>
      </Box>

      <Box role="tabpanel" hidden={value !== 0} sx={{ p: 1 }}>{value === 0 && <FuturesOpenOrders />}</Box>
      <Box role="tabpanel" hidden={value !== 1} sx={{ p: 1 }}>{value === 1 && <FuturesTradeHistory />}</Box>
    </Box>
  );
};

export default FuturesTradeTabs;
